<footer class="app-footer pageFoot" role="contentinfo">

  <!-- <div class="offcanvas-overlay"></div> -->
  <!-- <h2>Footer Information</h2> -->

  <p>&copy; <span>{{ appInformation }}</span></p>

  <ul class="footer-links">
    <li *ngFor="let data of modalDatas(); trackBy: trackByFunc">
      <button (click)="onModalOpen(data.title.value)" [innerHTML]="data.title.value"></button>
    </li>
  </ul>
</footer>

<ng-container *ngIf="showModal()">
  <app-modal-ok [modalTitle]="modalData().title.value" [modalIcon]="modalData().icon" [width]="modalData().width"
                (modalClose)="onModalClose()" (modalOk)="onModalClose()">
    <div class="app-footer-modal-body" [innerHTML]="modalData().body.value"></div>
  </app-modal-ok>
</ng-container>
